export default [
  {
    key: '1', name: '报表统计', icon: 'line-chart', submenus: [
      { key: '/report/sale_report', name: '销售报表', permission: 'sales_report' },
      { key: '/report/sales_rank', name: '销量排序', permission: 'sales_report' },
      { key: '/report/purchase_report', name: '采购报表', permission: 'purchase_report' },
      { key: '/report/stock_report', name: '库存报表', permission: 'inventory' },
      { key: '/report/income_expense_statistics', name: '收支统计', permission: 'finance_statistic' },
      { key: '/report/batch_report', name: '批次报表', permission: 'batch' },
    ]
  },
  {
    key: '2', name: '基础数据', icon: 'table', submenus: [
      { key: '/basicData/client', name: '客户管理', permission: 'client' },
      { key: '/basicData/supplier', name: '供应商管理', permission: 'supplier' },
      { key: '/basicData/warehouse', name: '仓库管理', permission: 'warehouse' },
      { key: '/basicData/settlement_account', name: '结算账户', permission: 'account' },
      { key: '/basicData/revenue_expenditure_items', name: '收支项目', permission: 'charge_item' },
    ]
  },
  {
    key: '3', name: '产品管理', icon: 'appstore', submenus: [
      { key: '/goods/classification', name: '产品分类', permission: 'goods_category' },
      { key: '/goods/unit', name: '产品单位', permission: 'goods_unit' },
      { key: '/goods/information', name: '产品信息', permission: 'goods' },
      { key: '/goods/temporary_warning', name: '临期预警', permission: 'goods' },
    ]
  },
  {
    key: '4', name: '采购管理', icon: 'shopping-cart', submenus: [
      { key: '/purchasing/purchase_create', name: '采购开单', permission: 'purchase_order' },
      { key: '/purchasing/purchase_record', name: '采购记录', permission: 'purchase_order' },
      { key: '/purchasing/purchase_price_ledger', name: '进货价明细', permission: 'goods_purchase_price' },
      { key: '/purchasing/purchase_return_create', name: '采购退货', permission: 'purchase_return_order' },
      { key: '/purchasing/return_record', name: '退货记录', permission: 'purchase_return_order' },
    ]
  },
  {
    key: '5', name: '销售管理', icon: 'shopping', submenus: [
      { key: '/sale/sale_create', name: '销售开单', permission: 'sales_order' },
      { key: '/sale/sale_record', name: '销售记录', permission: 'sales_order' },
      { key: '/sale/sale_return_create', name: '销售退货', permission: 'sales_return_order' },
      { key: '/sale/sale_return_record', name: '退货记录', permission: 'sales_return_order' },
    ]
  },
  {
    key: '7', name: '库存管理', icon: 'database', submenus: [
      { key: '/warehouse/inStock', name: '入库任务', permission: 'stock_in' },
      { key: '/warehouse/outStock', name: '出库任务', permission: 'stock_out' },
      { key: '/warehouse/inventory', name: '盘点', permission: 'stock_check' },
      { key: '/warehouse/allocation', name: '调拨', permission: 'stock_transfer' },
      { key: '/warehouse/flow', name: '库存流水', permission: 'inventory_flow' },
    ]
  },
  {
    key: '8', name: '财务管理', icon: 'dollar', submenus: [
      { key: '/finance/arrears_payable', name: '应付欠款', permission: 'supplier_arrears' },
      { key: '/finance/payment', name: '付款', permission: 'payment_order' },
      { key: '/finance/arrears_receivable', name: '应收欠款', permission: 'client_arrears' },
      { key: '/finance/collection', name: '收款', permission: 'collection_order' },
      { key: '/finance/account_transfer', name: '账户转账', permission: 'account_transfer_record' },
      { key: '/finance/income_and_pay', name: '日常收支', permission: 'charge_order' },
      { key: '/finance/flow', name: '资金流水', permission: 'finance_flow' },
    ]
  },
  {
    key: '10', name: '溯源管理', icon: 'qrcode', submenus: [
      { key: '/trace/batch', name: '生码管理', permission: 'trace_batch' },
      { key: '/trace/template', name: '展示模板', permission: 'trace_template' },
      { key: '/trace/code', name: '溯源码', permission: 'trace_code' },
      { key: '/trace/statistics', name: '扫码统计', permission: 'trace_statistic' },
    ]
  },
  {
    key: '11', name: '植保知识库', icon: 'experiment', submenus: [
      { key: '/plantProtect/pesticide', name: '农药手册' },
      { key: '/plantProtect/weed', name: '杂草手册' },
      { key: '/plantProtect/pest', name: '虫害手册' },
      { key: '/plantProtect/disease', name: '病害手册' },
    ]
  },
  {
    key: '12', name: '订购表单', icon: 'form', submenus: [
      { key: '/orderForm/forms', name: '表单管理' },
      { key: '/orderForm/orders', name: '订购订单' },
    ]
  },
  {
    key: '9', name: '系统管理', icon: 'team', submenus: [
      { key: '/role', name: '角色管理', managerOnly: true },
      { key: '/account', name: '员工账号', managerOnly: true },
      { key: '/config', name: '系统配置', managerOnly: true },
    ]
  },
]
